var m = Object.defineProperty;
var p = (r, e, i) => e in r ? m(r, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : r[e] = i;
var l = (r, e, i) => p(r, typeof e != "symbol" ? e + "" : e, i);
import { ALIGN_CLASSES_INVERSE as u, MENTION_CLASS as f, NO_MARGIN_CLASS as g } from "./constants.js";
import { decodeAttributes as k } from "./utils/attribute-encoding.js";
import { BlockListParser as M, DocumentHtmlEntityDecoder as b } from "@intercom/interblocks.ts";
class P {
  constructor(e, i) {
    l(this, "blockAttrs");
    l(this, "markMap");
    l(this, "nodeMap");
    l(this, "marks", ["b", "i", "a", "code", "u", "span"]);
    l(this, "nodes", ["p", "br", "ol", "ul", "li", "h1", "h2", "h3", "h4", "small", "pre", "img"]);
    this.documentBuilder = e, this.config = i;
    const t = e.schema;
    this.markMap = {
      b: t.marks.bold,
      i: t.marks.italic,
      a: t.marks.anchor,
      code: t.marks.code,
      u: t.marks.underline,
      span: t.marks.span
    }, this.nodeMap = {
      p: t.nodes.paragraph,
      ol: t.nodes.orderedList,
      ul: t.nodes.unorderedList,
      li: t.nodes.listItem,
      h1: t.nodes.heading,
      h2: t.nodes.subheading,
      h3: t.nodes.subheading3,
      h4: t.nodes.subheading4,
      small: t.nodes.small,
      pre: t.nodes.codeBlock,
      br: t.nodes.hardBreak,
      hr: t.nodes.horizontalLine,
      template: t.nodes.template,
      mention: t.nodes.mention,
      aiPromptData: t.nodes.aiPromptData,
      img: t.nodes.inlineImage
    };
  }
  handle(e, i) {
    M.parse(
      [e],
      new b(document),
      !!this.nodeMap.template,
      this.config.isPlaintext,
      !0,
      !1,
      !1
    ).body.forEach((a) => this.handleNode(a, i));
  }
  handleNode(e, i) {
    if (e.isElement)
      if (this.isMention(e))
        this.mention(e);
      else if (this.isAiPromptData(e))
        this.aiPromptData(e);
      else if (this.marks.includes(e.value ?? ""))
        this.mark(e);
      else if (this.nodes.includes(e.value ?? ""))
        this.node(e, i);
      else
        throw new Error(`unknown element type: ${e.value}`);
    else e.isLiteral ? this.documentBuilder.addText(e.value ?? "") : e.type === "Template" ? this.template(e) : (this.stashBlockAttrs(e), this.handleChildren(e.children ?? [], i));
  }
  node(e, i) {
    var c, o;
    const t = this.nodeMap[e.value ?? ""];
    if (!t)
      return;
    const a = this.collectAttrs(e), n = this.consumeBlockAttrs();
    if (this.addAlignment(a, n), this.addStyle(a), t === this.nodeMap.img) {
      const s = (c = e.attributes) == null ? void 0 : c.find((d) => d.name === "alt");
      s && (a.text = s.value);
      const h = (o = e.attributes) == null ? void 0 : o.find((d) => d.name === "data-class-name");
      h && (a.className = h.value);
    }
    if (this.documentBuilder.openNode(t, a), t === this.nodeMap.li) {
      const s = this.nodeMap.p;
      this.documentBuilder.openNode(s, {});
    }
    this.handleChildren(e.children ?? [], i), t === this.nodeMap.li && this.documentBuilder.closeNode(), this.documentBuilder.closeNode(), this.addExtraParagraphIfLegacyParagraph(e, n, i);
  }
  mark(e) {
    const i = this.markMap[e.value ?? ""];
    let t;
    i && this.documentBuilder.top().type.allowsMarkType(i) && (t = i.create(this.collectAttrs(e)), this.documentBuilder.openMark(t), i === this.markMap.a && this.handleInlineImageLinkUrl(t, e)), this.handleChildren(e.children ?? []), t && this.documentBuilder.closeMark(t);
  }
  mention(e) {
    var t, a;
    const i = this.collectAttrs(e);
    this.nodeMap.mention && (this.documentBuilder.openNode(this.nodeMap.mention, {
      name: ((a = (t = e.children) == null ? void 0 : t[0]) == null ? void 0 : a.value) ?? "",
      uri: i.href
    }), this.documentBuilder.closeNode());
  }
  aiPromptData(e) {
    let i = this.collectAttrs(e);
    const t = {};
    for (const [a, n] of Object.entries(i))
      if (typeof a == "string" && a.startsWith("data-prompt-data-")) {
        const o = a.split("-").slice(3).map((s, h) => h === 0 ? s : s.charAt(0).toUpperCase() + s.slice(1)).join("");
        t[o] = String(n);
      }
    i = t, this.nodeMap.aiPromptData && (this.documentBuilder.openNode(this.nodeMap.aiPromptData, i), this.documentBuilder.closeNode());
  }
  template(e) {
    this.nodeMap.template && (this.documentBuilder.openNode(this.nodeMap.template, {
      attributePath: e.value ?? "",
      fallback: e.fallback ?? ""
    }), this.documentBuilder.closeNode());
  }
  handleInlineImageLinkUrl(e, i) {
    var t, a;
    if (i.children && i.children.length === 1 && ((t = i.children[0]) == null ? void 0 : t.value) === "img") {
      const n = e.attrs.href ?? "";
      (a = i.children[0].attributes) == null || a.push({
        type: "Attribute",
        name: "linkUrl",
        value: n
      });
    }
  }
  collectAttrs(e) {
    var t;
    const i = {};
    return (t = e.attributes) == null || t.forEach((a) => {
      const n = k(a.value);
      i[a.name] ? i[a.name] += ` ${n}` : i[a.name] = n;
    }), e.type === "Block" && (i.type = e.value), e.isElement && e.id && (i.idAttribute = e.id), i;
  }
  stashBlockAttrs(e) {
    this.blockAttrs = this.collectAttrs(e);
  }
  consumeBlockAttrs() {
    const e = this.blockAttrs;
    return this.blockAttrs = void 0, e;
  }
  addAlignment(e, i) {
    !i || typeof i.class != "string" || i.class.split(" ").forEach((t) => {
      const a = u[t];
      a && Object.assign(e, { alignment: a });
    });
  }
  addStyle(e) {
    !e || typeof e.style != "string" || e.style.split(";").forEach((i) => {
      if (!i)
        return;
      const t = i.split(":", 2), a = t[0], n = t[1].trim();
      a === "font-family" && Object.assign(e, { fontFamily: n }), a === "color" && Object.assign(e, { fontColor: n }), a === "width" && Object.assign(e, { width: n.replace("px", "") });
    });
  }
  handleChildren(e, i) {
    e.forEach((t) => {
      this.handleNode(t, i);
    });
  }
  isMention(e) {
    var i;
    return !!(this.nodeMap.mention && e.value === "a" && ((i = e.attributes) != null && i.find((t) => t.name === "class" && t.value === f)));
  }
  isAiPromptData(e) {
    var i;
    return !!(this.nodeMap.aiPromptData && e.value === "span" && ((i = e.attributes) != null && i.find((t) => t.name === "data-ai-prompt-data")));
  }
  addExtraParagraphIfLegacyParagraph(e, i, t) {
    this.isParagraphWithImplicitMargin(e, i, t) && !this.config.singleBlockMode && !this.config.allowImplicitMarginParagraphs && (this.documentBuilder.openNode(this.nodeMap.p, {}), this.documentBuilder.closeNode());
  }
  isParagraphWithImplicitMargin(e, i, t) {
    return !i || !t ? !1 : e.value === "p" && !i.class.includes(g);
  }
}
export {
  P as TextBlockParser
};
